export const isAuthenticated = state => state.isAuthenticated;
export const user = state => state.user;